import type { HelpFile } from '../../types/help'
import { AccessProfileEditTestIds } from '../../../testids/AccessProfileEditTestIds'

export const accessProfileEditHelp: HelpFile = {
  docPage: '/docs/access/entitlements',
  texts: {
    [AccessProfileEditTestIds.accessProfileEditPage]:
      'Name, Beschreibung, Code und Risiko-Metadaten dieses Zugriffsprofils bearbeiten.',
  },
}
